import BasedataDialog from "./BasedataDialog";

export default BasedataDialog;
